import React, { useState } from "react";
import styles from "./ManageUser.module.scss";
import Stepper from "./stepper/Stepper";
import StepAccount from "./steps/stepAccount/StepAccount";
import StepSubscription from "./steps/stepSubscription/StepSubscription";
import StepCabine from "./steps/stepCabine/StepCabine";
import StepSummary from "./steps/stepSummary/StepSummary";
import Button from "components/UiComponents/Button";



const ManageUser = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [triggerValidation, setTriggerValidation] = useState(0);

  // État global pour toutes les données utilisateur
  const [userData, setUserData] = useState({
    // Step Account
    login: "",
    name: "",
    lastName: "",
    email: "",
    password: "",

    // Step Subscription
    subscription: "",
    plan: "",
    subid: "",

    // Step Cabine
    cabine: "",
    typeCabine: "",

    // Step Summary - données finales
    createdAt: null,
    isValid: false
  });

  // Fonction pour mettre à jour les données utilisateur
  const updateUserData = (newData) => {
    setUserData(prevData => ({
      ...prevData,
      ...newData
    }));
  };

  // Fonction de validation pour chaque étape
  const validateCurrentStep = () => {
    switch (currentStep) {
      case 1:
        // Déclencher la validation dans StepAccount
        setTriggerValidation(prev => prev + 1);
        // Attendre un petit délai pour laisser la validation se faire, puis vérifier
        setTimeout(() => {
          // Vérifier si les champs requis sont remplis
          if (userData.login && userData.email && userData.password) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(userData.email)) {
              setCurrentStep(2);
            }
          }
        }, 100);
        return false; // On retourne false pour ne pas avancer immédiatement
      case 2:
        // Validation de l'étape Subscription (si nécessaire)
        return true;
      case 3:
        // Validation de l'étape Cabine (si nécessaire)
        return true;
      default:
        return true;
    }
  };

  // Fonction pour passer à l'étape suivante avec validation
  const goToNextStep = () => {
    if (validateCurrentStep()) {
      setCurrentStep(Math.min(steps.length, currentStep + 1));
    }
  };

  const steps = [
    "Compte",
    "Abonnement",
    "Cabine",
    "Résumé"
  ];

  return (
    <div className={styles.container}>
      <Stepper currentStep={currentStep} steps={steps} />

      <div className={styles.content}>
        {currentStep === 1 && (
          <StepAccount
            userData={userData}
            updateUserData={updateUserData}
            triggerValidation={triggerValidation}
          />
        )}
        {currentStep === 2 && (
          <StepSubscription
            userData={userData}
            updateUserData={updateUserData}
            onNext={() => setCurrentStep(3)}
            onPrev={() => setCurrentStep(1)}
          />
        )}
        {currentStep === 3 && (
          <StepCabine
            userData={userData}
            updateUserData={updateUserData}
            onNext={() => setCurrentStep(4)}
            onPrev={() => setCurrentStep(2)}
          />
        )}
        {currentStep === 4 && (
          <StepSummary
            userData={userData}
            updateUserData={updateUserData}
            onPrev={() => setCurrentStep(3)}
            onSave={() => {
              // Action finale de sauvegarde
              console.log("Données finales à sauvegarder:", userData);
              // Ici vous pouvez appeler votre API
            }}
          />
        )}

        {/* <CreateAccountUser /> */}

        {/* Boutons de navigation pour démonstration */}
        <div className={styles.navigationButtons}>
          {currentStep > 1 && (
            <Button
              type="button"
              onPress={() => setCurrentStep(Math.max(1, currentStep - 1))}
              text="Précédent"
              styles={"btnPrimary"}
            />
          )}
          {currentStep < steps.length && (
            <Button
              type="button"
              onPress={goToNextStep}
              text="Suivant"
              styles={"btnPrimary"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageUser;
